export interface LicenceSummaryDTO {
  availableLicences: number | null;
  companyName      : string;
  totalLicences    : number | null;
  usedLicences     : number | null;
};

export interface CompanyLicenceSummaryDTO {
  availableLicences: number | null;
  companies        : LicenceSummaryDTO[] | null;
  totalLicences    : number | null;
  usedLicences     : number | null;
};

export function CompanyLicenceSummaryDTO_EmptyObject(): CompanyLicenceSummaryDTO {
  return {
    availableLicences: 0,
    companies        : [],
    totalLicences    : 0,
    usedLicences     : 0
  };
};
